import React, { useRef, useState } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import { reviews } from "../../../Data/Data";
import Review from "./Review";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";

const Recommendation = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const arrowRef = useRef();
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    afterChange: (index) => setCurrentSlide(index),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
    ],
  };

  let displaySlider = reviews.map((item, i) => <Review item={item} key={i} />);

  const next = () => arrowRef.current.slickNext();
  const prev = () => arrowRef.current.slickPrev();

  const totalSlides = reviews.length;
  const slidesToShow = 2;
  return (
    <Content>
      <h2>What my clients said</h2>
      <Slider ref={arrowRef} {...settings}>
        {displaySlider}
      </Slider>
      <div className="!hidden md:!flex !items-center !justify-between !absolute !top-[55%] !-left-6 !-right-6">
        <button
          disabled={currentSlide === 0}
          onClick={prev}
          className={`border border-white p-1 transition-all duration-500 ${
            currentSlide === 0
              ? "opacity-30 cursor-not-allowed"
              : "hover:bg-skyBlue hover:text-black"
          }`}
        >
          <IoIosArrowBack />
        </button>
        <button
          disabled={currentSlide === totalSlides}
          onClick={next}
          className={`border border-white p-1 transition-all duration-500 ${
            currentSlide >= totalSlides - slidesToShow
              ? "opacity-30 cursor-not-allowed"
              : "hover:bg-skyBlue hover:text-black"
          }`}
        >
          <IoIosArrowForward />
        </button>
      </div>
    </Content>
  );
};

export default Recommendation;

const Content = styled.div`
  position: relative;
  h2 {
    font-size: 1rem;
    padding: 1.5rem 0;
  }
`;
